import React, { useContext } from "react";
import { userContext } from "../Context/userContext";
import siteConfig from "../config/siteConfig";
import "../css/LynxStyle.css";

const SECTIONS = [
  {
    title: "Lifestyle 💪",
    items: [{ type: "BMI", icon: "🧮", label: "BMI & Calories" }],
  },
  {
    title: "Fun Tools 🎉",
    items: [
      { type: "love", icon: "💘", label: "Love Calculator" },
      { type: "daysalive", icon: "🎂", label: "Days Alive Counter" },
      { type: "water", icon: "💧", label: "Water Intake" },
      { type: "sleep", icon: "😴", label: "Ideal Sleep" },
      { type: "tip", icon: "🧾", label: "Tip Calculator" },
      { type: "whichlynx", icon: "🐾", label: "Which Lynx Are You?" },
    ],
  },
  {
    title: "Content 🎁",
    items: [
      { type: "image", icon: "🖼️", label: "Images" },
      { type: "audio", icon: "🎵", label: "Music" },
      { type: "wallpaper", icon: "🌄", label: "Wallpapers" },
      { type: "zoom", icon: "🖥️", label: "Zoom Backgrounds" },
    ],
  },
  {
    title: "Games 🕹️",
    items: [
      { type: "BHGame", icon: "🕳️", label: "Black Hole Game" },
      { type: "AllGames", icon: "🕹️", label: "All Games!" },
    ],
  },
];

const Dashboard = () => {
  const { setcontentType } = useContext(userContext);

  const go = (type) => setcontentType(type);

  return (
    <div className="container-fluid dashboard-hero lynx-background">
      <div className="container">
        <div className="dashboard-greeting text-center">
          <img
            src={siteConfig.images.mascot}
            className="mascot-img dashboard-mascot"
            alt=""
          />
          <h2 className="text-lynx fw-bold">Hey there! 👋</h2>
          <p className="dashboard-tagline">{siteConfig.tagline}</p>
          <button className="btn-lynx" onClick={() => go("winners")}>
            🏆 Check if you're a Winner!
          </button>
        </div>

        {SECTIONS.map((section) => (
          <div key={section.title} className="dashboard-section">
            <span className="sidebar-section-title">{section.title}</span>
            <div className="sidebar-tile-grid dashboard-tile-grid">
              {section.items.map((item) => (
                <button
                  key={item.type}
                  className="sidebar-tile"
                  onClick={() => go(item.type)}
                >
                  <span className="sidebar-tile-icon">{item.icon}</span>
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
